import { useFeatureGate } from '@atlassian/feature-gates-react';

import { AidFrontendFeatureGate } from '../providers/FeatureGates';
import { useAwsWafConfig } from './use-aws-waf-config';
import { useAwsWafCaptchaSdkScript } from './use-aws-waf-captcha-sdk-script';

/**
 * Loads the AWS WAF CAPTCHA SDK for the page only when its feature gate is enabled
 * and a valid configuration is available.
 */
export const MaybeLoadAwsCaptchaSdkScript = () => {
  const isFeatureEnabled = useFeatureGate(AidFrontendFeatureGate.ENABLE_AWS_WAF_CAPTCHA);
  const awsWafConfig = useAwsWafConfig();

  useAwsWafCaptchaSdkScript(isFeatureEnabled ? awsWafConfig : null);

  return null;
};
